// userEmail — resolve o email do usuário logado a partir do storage local.
// Mesmo padrão de confiança usado nos fluxos de cotação (PO1-2082): o
// backend confia no email vindo do payload, pois APP_SECRET (hub-backend) e
// JWT_SECRET (backend_hub) divergem e não dá pra revalidar o JWT lá.
//
// Cascata: (1) decodifica o JWT em "@HubEverlog:token" e pega
// loggedUser.email/email; (2) fallback "@HubEverlog:user".username se for
// um email; (3) null.

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function obterUserEmail() {
  try {
    const token = localStorage.getItem("@HubEverlog:token");
    if (token) {
      const payload = token.split(".")[1];
      const decoded = JSON.parse(
        decodeURIComponent(
          atob(payload.replace(/-/g, "+").replace(/_/g, "/"))
            .split("")
            .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
            .join("")
        )
      );
      return (decoded.loggedUser && decoded.loggedUser.email) || decoded.email || null;
    }
  } catch (_) {
    // ignore
  }
  try {
    const userRaw = localStorage.getItem("@HubEverlog:user");
    if (userRaw) {
      const parsedUser = JSON.parse(userRaw);
      const candidato = parsedUser?.username || null;
      if (candidato && emailRegex.test(candidato)) return candidato;
    }
  } catch (_) {
    // ignore
  }
  return null;
}
